import { environment } from 'src/environments/environment';
import { GiphyFetch } from '@giphy/js-fetch-api';
import { Injectable } from '@angular/core';

@Injectable()
export class GiphyService {
  gf: any;
  imageGiphy: any;
  isShowGif: boolean;

  constructor() {
    this.gf = new GiphyFetch(`${environment.giphyApiKey}`);
    this.imageGiphy = '';
    this.isShowGif = false;
  }

  async fetch() {
    try {
      const result = await this.gf.trending();
      return result;
    } catch (error) {
      console.error(`error:`, error);
      return error;
    }
  }

  async search(value) {
    try {
      const result = await this.gf.search(value, { rating: 'pg' });
      return result;
    } catch (error) {
      console.error(`search`, error);
      return error;
    }
  }

  showHideGiphy() {
    this.isShowGif = !this.isShowGif;
  }

  setImage(image) {
    this.imageGiphy = image;
  }
}
